import appGlobalScript from '/home/runner/_work/marketing-engine-frontend/marketing-engine-frontend/source/global-script.ts';
export const globalScripts = appGlobalScript;
